import { atomWithStorage } from 'jotai/utils';

/**
 * 選択済みプロジェクトIDをローカルストレージで管理する atom
 */
export const selectedProjectIdAtom = atomWithStorage<string>(
  'transfer_selected_project_id',
  '',
);
